export const SingSaverRewardsSectionId = '#singsaver_rewards_section';

/**
 * Fixed GA4 `component_title` for Hot Reward cell clicks, so en-hk / zh-hk and any CMS header
 * wording land in one metric (CMS-1685, Airtable #2239).
 */
export const HOT_REWARD_TRACKING_TITLE = 'Hot Rewards';

/**
 * Reward cells link to the product's reward details: underlined at rest where there is no hover to
 * reveal the link (touch devices, any width); hover-only where the pointer can hover (CMS-2005).
 */
export const REWARD_CELL_LINK_CLASSES =
  'underline [@media(hover:hover)]:no-underline hover:underline';

/**
 * Display at most 6 product attributes in a comparison table (CMS-1368). Mirrors the `max: 6` on
 * `attributes_list` in the Strapi schema - if either moves, move both. The per-page-type limits an
 * earlier version of this comment described (3 for articles, 4 otherwise) are not implemented.
 */
export const ATTRIBUTE_COLUMNS_MAX = 6;
